import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="no-print border-t border-carbon bg-paper" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 grid gap-10 md:grid-cols-3">
      <div>
        <div className="t-head text-2xl tracking-[0.08em]">LONGHAND</div>
        <p className="t-body text-base text-olive mt-3 max-w-xs">Operating practice from before the machine.</p>
        <p className="t-body text-base text-olive mt-1 max-w-xs italic">We install the controls that don't need a password.</p>
      </div>
      <div className="grid grid-cols-2 gap-6">
        <div className="flex flex-col gap-2">
          <span className="t-label text-rule">Index</span>
          <Link to="/audit" className="t-label text-carbon hover:text-stamp" data-testid="footer-audit">The Audit</Link>
          <Link to="/team" className="t-label text-carbon hover:text-stamp" data-testid="footer-team">Team Audit</Link>
          <Link to="/paper" className="t-label text-carbon hover:text-stamp" data-testid="footer-paper">The Paper</Link>
          <Link to="/modules" className="t-label text-carbon hover:text-stamp" data-testid="footer-modules">Modules</Link>
          <Link to="/method" className="t-label text-carbon hover:text-stamp" data-testid="footer-method">Method</Link>
          <Link to="/pricing" className="t-label text-carbon hover:text-stamp" data-testid="footer-pricing">Schedule of Fees</Link>
          <Link to="/dealers" className="t-label text-carbon hover:text-stamp" data-testid="footer-dealers">Dealers</Link>
          <Link to="/portal" className="t-label text-carbon hover:text-stamp" data-testid="footer-portal">Client File</Link>
          <Link to="/terms" className="t-label text-carbon hover:text-stamp" data-testid="footer-terms">Terms</Link>
          <Link to="/privacy" className="t-label text-carbon hover:text-stamp" data-testid="footer-privacy">Privacy</Link>
          <Link to="/authorization-agreement" className="t-label text-carbon hover:text-stamp" data-testid="footer-agreement">Authorization Agreement</Link>
        </div>
        <div className="flex flex-col gap-2">
          <span className="t-label text-rule">Firm</span>
          <Link to="/about" className="t-label text-carbon hover:text-stamp" data-testid="footer-about">About</Link>
          <Link to="/contact" className="t-label text-carbon hover:text-stamp" data-testid="footer-contact">Contact</Link>
          <Link to="/admin" className="t-label text-rule hover:text-carbon" data-testid="footer-admin">Internal</Link>
        </div>
      </div>
      <div className="t-label text-olive md:text-right flex flex-col gap-1 md:items-end">
        <span>Form LH-00 — Rev. 09/26</span>
        <span>© {new Date().getFullYear()} Longhand. All rights reserved.</span>
        <span className="text-rule">Training and operating practice. Not legal, compliance, or cybersecurity services.</span>
      </div>
    </div>
  </footer>
);
